import type {ReactElement} from 'react';
import React from 'react';
import styles from '../../share-panel.module.scss';
import {Text, TextSize} from '@Components/text';
import {InputField} from '@Components/input-field-v2';
import type {ShareViaLinkProps} from '@Panels/share-panel/components/share-via-link/share-via-link.types';
import {CopyLinkButton} from '@Components/copy-link-button/copy-link-button';
import {Size, Type} from '@Components/button';
import {ShareAccessOptionsDropdown} from '@Panels/share-panel/components/share-access-options-dropdown/share-access-options-dropdown';
import {noop} from '@Utils/general.util';

export function ShareViaLink({
  sharedLink,
  placeholderText,
  itemPermissionLevel,
  accessDropdownOptions,
  popupClassName = '',
  popupSelectorClassName = '',
  inputFieldClassName = '',
  doClosePopupOnInnerClick = false,
  isMobile = false,
  onCopyLink = noop,
  ...props
}: ShareViaLinkProps): ReactElement {
  const getCopyLinkButton = (): ReactElement => {
    return (
      <CopyLinkButton
        key="copy-shareable-link"
        linkToCopy={sharedLink}
        tooltipTimeout={1000}
        buttonProps={{
          type: Type.SECONDARY,
          size: Size.SMALL,
          customClasses: `${isMobile ? '_full-width' : 'spacing-m-l-2'} ${styles.panelButton}`,
          onClick: onCopyLink,
        }}
        showSuccessColorIconOnCopy
        doChangeIconOnCopy
      />
    );
  };

  const getShareLinkInputField = (): ReactElement => {
    return (
      <div className={`${styles.inputFieldWrapper} flex-h-row _full-width flex-justify-between radius-4 border-s-dark hover-transition-all`}>
        <InputField
          input={sharedLink}
          placeholder={placeholderText}
          className={`${inputFieldClassName} ${styles.dropdownContainer}`}
          inputClassName={`_borderless ${styles.disabledInput}`}
          isReadOnly
        />
        <ShareAccessOptionsDropdown
          permissionLevelLabel={itemPermissionLevel}
          accessDropdownOptions={accessDropdownOptions}
          popupClassName={popupClassName}
          popupSelectorClassName={popupSelectorClassName}
          doCloseOnInnerClick={doClosePopupOnInnerClick}
          showTooltip={props.showTooltipForOpts}
          tooltipText={props.tooltipText}
        />
      </div>
    );
  };

  return (
    <div className="flex-v-row">
      <div className="capitalize-sentence spacing-p-b-1">
        <Text val={window.i18next.t('pmwjs_invite_link')} size={TextSize.XSMALL} bold className="content-body" />
      </div>
      <div className={`${isMobile ? 'flex-v-row' : 'flex-h-row'} ${isMobile ? styles.sharingOptionsMobile : ''}`}>
        {getShareLinkInputField()}
        {getCopyLinkButton()}
      </div>
    </div>
  );
}
